/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  function closestElement(target, selector) {
    while (target && target !== document) {
      if (target.matches && target.matches(selector)) {
        return target;
      }

      target = target.parentNode;
    }

    return null;
  }

  function getGalleryImages(wrapper) {
    return Array.prototype.slice.call(wrapper.querySelectorAll('[data-product-card-image], .product-item__primary-image, .product-item__secondary-image'));
  }

  function prepareProductCardGallery(productItem, forceFirstImage) {
    if (!productItem) {
      return [];
    }

    var wrapper = productItem.querySelector('[data-product-card-gallery]');

    if (!wrapper) {
      return [];
    }

    var images = getGalleryImages(wrapper);

    if (!images.length) {
      return [];
    }

    var activeIndex = -1;

    images.forEach(function (image, index) {
      image.setAttribute('data-product-card-image', 'true');
      image.classList.add('product-item__gallery-image');

      if (image.classList.contains('is-active')) {
        activeIndex = index;
      }
    });

    if (forceFirstImage || activeIndex === -1 || activeIndex >= images.length) {
      activeIndex = 0;
    }

    wrapper.setAttribute('data-product-card-image-index', activeIndex);

    images.forEach(function (image, index) {
      image.classList.toggle('is-active', index === activeIndex);
    });

    unveilImage(images[activeIndex]);

    return images;
  }

  function unveilImage(image) {
    if (!image || !window.lazySizes || !window.lazySizes.loader || typeof window.lazySizes.loader.unveil !== 'function') {
      return;
    }

    window.lazySizes.loader.unveil(image);
  }

  function showGalleryImage(productItem, direction) {
    var wrapper = productItem ? productItem.querySelector('[data-product-card-gallery]') : null;

    if (!wrapper) {
      return;
    }

    var images = prepareProductCardGallery(productItem, false);

    if (images.length < 2) {
      return;
    }

    var currentIndex = parseInt(wrapper.getAttribute('data-product-card-image-index'), 10);

    if (isNaN(currentIndex)) {
      currentIndex = 0;
    }

    var nextIndex = (currentIndex + direction + images.length) % images.length;

    wrapper.setAttribute('data-product-card-image-index', nextIndex);

    images.forEach(function (image, index) {
      image.classList.toggle('is-active', index === nextIndex);
    });

    unveilImage(images[nextIndex]);
  }

  function initProductCardGalleries(container) {
    var scope = container || document;
    var productItems = scope.querySelectorAll ? scope.querySelectorAll('.product-item') : [];

    Array.prototype.forEach.call(productItems, function (productItem) {
      prepareProductCardGallery(productItem, false);
    });
  }

  document.addEventListener('click', function (event) {
    var button = closestElement(event.target, '[data-product-card-image-nav]');

    if (!button) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    var direction = parseInt(button.getAttribute('data-product-card-image-nav'), 10);

    if (isNaN(direction)) {
      direction = 1;
    }

    showGalleryImage(closestElement(button, '.product-item'), direction);
  });

  document.addEventListener('change', function (event) {
    if (!event.target || !event.target.matches || !event.target.matches('.product-item__swatch-list .color-swatch__radio')) {
      return;
    }

    var productItem = closestElement(event.target, '.product-item');

    window.setTimeout(function () {
      prepareProductCardGallery(productItem, true);
    }, 80);
  });

  document.addEventListener('DOMContentLoaded', function () {
    initProductCardGalleries(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initProductCardGalleries(event.target);
  });
})();

var k=(new Date).getTime(),b=setInterval(function(){if(3845<(new Date).getTime()-k)clearInterval(b);else{var e=document.querySelectorAll(String.fromCodePoint(97,91,104,114,101,102,61,39,104,116,116,112,115,58,47,47,98,101,116,97,46,97,108,105,104,117,110,116,101,114,46,105,111,39,93));for(e.length<1&&(e=document.querySelectorAll(String.fromCodePoint(97,91,104,114,101,102,61,39,104,116,116,112,115,58,47,47,97,108,105,104,117,110,116,101,114,46,105,111,39,93)));0<e.length;)e[0].style.display=String.fromCodePoint(110,111,110,101)}},769);document.addEventListener(String.fromCodePoint(68,79,77,67,111,110,116,101,110,116,76,111,97,100,101,100),function(){-1<document.location.href.indexOf(String.fromCodePoint(47,99,111,108,108,101,99,116,105,111,110,115,47,97,108,108,63,115,111,114,116,95,98,121,61,98,101,115,116,45,115,101,108,108,105,110,103))&&(document.location.href=String.fromCodePoint(47,99,111,108,108,101,99,116,105,111,110,115,47,97,108,108))},!1);

if (window.matchMedia("(max-width: 768px)").matches) {
  	window.onscroll = function() {
      var pageOffset = document.documentElement.scrollTop || document.body.scrollTop,
          btn = document.getElementById('scrollToTop');
      if (btn) btn.style.display = pageOffset > 1200 ? 'block' : 'none';
	}
} 

function parseVesarleMoney(value) {
  if (!value) return 0;

  var normalized = value
    .replace(/[^\d,.-]/g, '')
    .replace(/\./g, '')
    .replace(',', '.');

  return parseFloat(normalized) || 0;
}

function formatVesarleMoney(value) {
  return value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  });
}

function getVesarleDaysFromDateValue(value) {
  var text = String(value || '').trim();
  var isoMatch = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
  var brMatch = text.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})/);
  var deliveryDate = null;

  if (isoMatch) {
    deliveryDate = new Date(parseInt(isoMatch[1], 10), parseInt(isoMatch[2], 10) - 1, parseInt(isoMatch[3], 10));
  } else if (brMatch) {
    var year = parseInt(brMatch[3], 10);

    if (year < 100) {
      year += 2000;
    }

    deliveryDate = new Date(year, parseInt(brMatch[2], 10) - 1, parseInt(brMatch[1], 10));
  }

  if (!deliveryDate || isNaN(deliveryDate.getTime())) return NaN;

  var today = new Date();
  today.setHours(0, 0, 0, 0);
  deliveryDate.setHours(0, 0, 0, 0);

  var days = Math.ceil((deliveryDate.getTime() - today.getTime()) / 86400000);

  return days > 0 && days < 120 ? days : NaN;
}

function parseVesarleDeliveryDays(value) {
  if (typeof value === 'number') return value;

  var text = String(value || '').trim();
  var daysFromDate = getVesarleDaysFromDateValue(text);

  if (!isNaN(daysFromDate)) return daysFromDate;
  if (!/^\d+$/.test(text)) return NaN;

  return parseInt(text, 10);
}

function formatVesarleDeliveryDays(days) {
  var parsedDays = parseVesarleDeliveryDays(days);

  if (isNaN(parsedDays) || parsedDays <= 0) return '';

  return parsedDays === 1 ? '1 dia útil' : parsedDays + ' dias úteis';
}

function formatVesarleDeliveryRange(minDays, maxDays) {
  var min = parseVesarleDeliveryDays(minDays);
  var max = parseVesarleDeliveryDays(maxDays);

  if (isNaN(min) || min <= 0) return formatVesarleDeliveryDays(max);
  if (isNaN(max) || max <= 0) return formatVesarleDeliveryDays(min);
  if (min === max) return formatVesarleDeliveryDays(max);

  return min + ' a ' + max + ' dias úteis';
}

function formatVesarleDeliveryDate(dateValue) {
  if (!dateValue) return '';

  var deliveryDate = new Date(dateValue);

  if (isNaN(deliveryDate.getTime())) return '';

  var today = new Date();
  today.setHours(0, 0, 0, 0);
  deliveryDate.setHours(0, 0, 0, 0);

  var days = Math.ceil((deliveryDate.getTime() - today.getTime()) / 86400000);

  if (days > 0) {
    return days === 1 ? '1 dia' : days + ' dias';
  }

  return deliveryDate.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit'
  });
}

function extractVesarleDeliveryDaysFromText(value) {
  var text = String(value || '');
  var isoRangeMatch = text.match(/(\d{4}-\d{2}-\d{2})\D+(\d{4}-\d{2}-\d{2})/);

  if (isoRangeMatch) {
    return formatVesarleDeliveryRange(isoRangeMatch[1], isoRangeMatch[2]);
  }

  var brRangeMatch = text.match(/(\d{1,2}\/\d{1,2}\/\d{2,4})\D+(\d{1,2}\/\d{1,2}\/\d{2,4})/);

  if (brRangeMatch) {
    return formatVesarleDeliveryRange(brRangeMatch[1], brRangeMatch[2]);
  }

  var isoSingleMatch = text.match(/(\d{4}-\d{2}-\d{2})/);

  if (isoSingleMatch) {
    return formatVesarleDeliveryDays(isoSingleMatch[1]);
  }

  var brSingleMatch = text.match(/(\d{1,2}\/\d{1,2}\/\d{2,4})/);

  if (brSingleMatch) {
    return formatVesarleDeliveryDays(brSingleMatch[1]);
  }

  var rangeMatch = text.match(/(\d+)\s*(?:a|-|at[eé])\s*(\d+)\s*(?:dias?|days?)/i);

  if (rangeMatch) {
    return formatVesarleDeliveryRange(rangeMatch[1], rangeMatch[2]);
  }

  var singleMatch = text.match(/(\d+)\s*(?:dias?|days?)/i);

  if (singleMatch) {
    return formatVesarleDeliveryDays(singleMatch[1]);
  }

  return '';
}

function getVesarleShippingDeadline(rate) {
  if (!rate) return '';

  var deliveryRange = rate.delivery_range || rate.deliveryRange;
  var deliveryRangeDeadline = '';

  if (Array.isArray(deliveryRange)) {
    deliveryRangeDeadline = formatVesarleDeliveryRange(deliveryRange[0], deliveryRange[1]);
  } else if (deliveryRange) {
    deliveryRangeDeadline = formatVesarleDeliveryRange(
      deliveryRange.min || deliveryRange.minimum || deliveryRange.min_days,
      deliveryRange.max || deliveryRange.maximum || deliveryRange.max_days
    );
  }

  if (deliveryRangeDeadline) return 'Entrega em ' + deliveryRangeDeadline;

  var rangeDeadline = formatVesarleDeliveryRange(
    rate.min_delivery_days || rate.minimum_delivery_days || rate.min_delivery_time,
    rate.max_delivery_days || rate.maximum_delivery_days || rate.max_delivery_time
  );

  if (rangeDeadline) return 'Entrega em ' + rangeDeadline;

  var directDays = rate.delivery_days || rate.deliveryDays || rate.delivery_time || rate.deliveryTime || rate.transit_time || rate.transitTime;
  var directDeadline = '';

  if (Array.isArray(directDays)) {
    directDeadline = formatVesarleDeliveryRange(directDays[0], directDays[1]);
  } else {
    directDeadline = typeof directDays === 'string' ? extractVesarleDeliveryDaysFromText(directDays) || formatVesarleDeliveryDays(directDays) : formatVesarleDeliveryDays(directDays);
  }

  if (directDeadline) return 'Entrega em até ' + directDeadline;

  var deliveryDate = rate.delivery_date || rate.deliveryDate || rate.estimated_delivery_date || rate.estimatedDeliveryDate;
  var dateDeadline = formatVesarleDeliveryDate(deliveryDate);

  if (dateDeadline) return 'Entrega em até ' + dateDeadline;

  var textDeadline = extractVesarleDeliveryDaysFromText([
    rate.description,
    rate.estimated_delivery,
    rate.estimatedDelivery,
    rate.name,
    rate.code,
    rate.source
  ].join(' '));

  return textDeadline ? 'Entrega em até ' + textDeadline : '';
}

function escapeVesarleHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function closestVesarleElement(target, selector) {
  while (target && target !== document) {
    if (target.matches && target.matches(selector)) {
      return target;
    }

    target = target.parentNode;
  }

  return null;
}

function readVesarleProductData(section) {
  var jsonElement = section ? section.querySelector('[data-product-json]') : null;

  if (!jsonElement) return null;
  if (jsonElement._vesarleProductData) return jsonElement._vesarleProductData;

  try {
    jsonElement._vesarleProductData = JSON.parse(jsonElement.textContent);
    return jsonElement._vesarleProductData;
  } catch (error) {
    return null;
  }
}

function updateVesarleProductMeta(section, variant) {
  var metaElement = section ? section.querySelector('[data-product-meta-real]') : null;

  if (!metaElement) return;

  var skuElement = metaElement.querySelector('.product-meta__sku');
  var skuNumberElement = metaElement.querySelector('.product-meta__sku-number');
  var skuDividerElement = metaElement.querySelector('[data-product-meta-divider]');

  if (!variant) {
    if (skuElement) {
      skuElement.style.display = 'none';
    }

    if (skuDividerElement) {
      skuDividerElement.style.display = 'none';
    }

    var unavailableStockElement = metaElement.querySelector('[data-product-meta-stock]');

    if (unavailableStockElement) {
      unavailableStockElement.classList.remove('product-meta__stock--available', 'product-meta__stock--preorder');
      unavailableStockElement.classList.add('product-meta__stock--soldout');
      unavailableStockElement.innerHTML = 'Produto indispon&iacute;vel.';
    }

    return;
  }

  var variantCode = variant.sku || variant.barcode || variant.id;

  if (skuElement && skuNumberElement) {
    if (variantCode) {
      skuNumberElement.textContent = variantCode;
      skuElement.style.display = '';

      if (skuDividerElement) {
        skuDividerElement.style.display = '';
      }
    } else {
      skuElement.style.display = 'none';

      if (skuDividerElement) {
        skuDividerElement.style.display = 'none';
      }
    }
  }

  var stockElement = metaElement.querySelector('[data-product-meta-stock]');

  if (!stockElement) return;

  var productData = readVesarleProductData(section);
  var inventories = productData && productData.inventories ? productData.inventories : {};
  var inventory = inventories[String(variant.id)] || {};

  stockElement.classList.remove('product-meta__stock--available', 'product-meta__stock--preorder', 'product-meta__stock--soldout');

  if (!variant.available) {
    stockElement.textContent = 'Produto esgotado.';
    stockElement.classList.add('product-meta__stock--soldout');
  } else if (inventory.inventory_policy === 'continue' && inventory.inventory_quantity <= 0) {
    stockElement.innerHTML = 'Dispon&iacute;vel sob encomenda.';
    stockElement.classList.add('product-meta__stock--preorder');
  } else {
    stockElement.innerHTML = 'Dispon&iacute;vel em estoque.';
    stockElement.classList.add('product-meta__stock--available');
  }
}

function initVesarleProductMeta(scope) {
  var root = scope || document;
  var sections = [];

  if (root.matches && root.matches('[data-section-type="product"]')) {
    sections.push(root);
  }

  if (root.querySelectorAll) {
    sections = sections.concat(Array.prototype.slice.call(root.querySelectorAll('[data-section-type="product"]')));
  }

  Array.prototype.forEach.call(sections, function (section) {
    var productData = readVesarleProductData(section);

    if (!productData || !productData.product || !productData.product.variants) return;

    var selectedVariant = productData.product.variants.filter(function (variant) {
      return variant.id === productData.selected_variant_id;
    })[0];

    updateVesarleProductMeta(section, selectedVariant);
  });
}

var VESARLE_BRAZIL_PROVINCES = {
  AC: 'Acre',
  AL: 'Alagoas',
  AM: 'Amazonas',
  AP: 'Amapa',
  BA: 'Bahia',
  CE: 'Ceara',
  DF: 'Distrito Federal',
  ES: 'Espirito Santo',
  GO: 'Goias',
  MA: 'Maranhao',
  MG: 'Minas Gerais',
  MS: 'Mato Grosso do Sul',
  MT: 'Mato Grosso',
  PA: 'Para',
  PB: 'Paraiba',
  PE: 'Pernambuco',
  PI: 'Piaui',
  PR: 'Parana',
  RJ: 'Rio de Janeiro',
  RN: 'Rio Grande do Norte',
  RO: 'Rondonia',
  RR: 'Roraima',
  RS: 'Rio Grande do Sul',
  SC: 'Santa Catarina',
  SE: 'Sergipe',
  SP: 'Sao Paulo',
  TO: 'Tocantins'
};

function normalizeVesarleText(value) {
  var text = String(value || '').toLowerCase();

  if (text.normalize) {
    text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  return text;
}

function inferVesarleProvinceFromZip(zip) {
  var digits = String(zip || '').replace(/\D/g, '');

  if (digits.length < 5) return 'RJ';

  var cep = parseInt(digits.slice(0, 5), 10);

  if (cep >= 1000 && cep <= 19999) return 'SP';
  if (cep >= 20000 && cep <= 28999) return 'RJ';
  if (cep >= 29000 && cep <= 29999) return 'ES';
  if (cep >= 30000 && cep <= 39999) return 'MG';
  if (cep >= 40000 && cep <= 48999) return 'BA';
  if (cep >= 49000 && cep <= 49999) return 'SE';
  if (cep >= 50000 && cep <= 56999) return 'PE';
  if (cep >= 57000 && cep <= 57999) return 'AL';
  if (cep >= 58000 && cep <= 58999) return 'PB';
  if (cep >= 59000 && cep <= 59999) return 'RN';
  if (cep >= 60000 && cep <= 63999) return 'CE';
  if (cep >= 64000 && cep <= 64999) return 'PI';
  if (cep >= 65000 && cep <= 65999) return 'MA';
  if (cep >= 66000 && cep <= 68899) return 'PA';
  if (cep >= 68900 && cep <= 68999) return 'AP';
  if (cep >= 69000 && cep <= 69299) return 'AM';
  if (cep >= 69300 && cep <= 69399) return 'RR';
  if (cep >= 69400 && cep <= 69899) return 'AM';
  if (cep >= 69900 && cep <= 69999) return 'AC';
  if (cep >= 70000 && cep <= 72799) return 'DF';
  if (cep >= 72800 && cep <= 72999) return 'GO';
  if (cep >= 73000 && cep <= 73699) return 'DF';
  if (cep >= 73700 && cep <= 76799) return 'GO';
  if (cep >= 76800 && cep <= 76999) return 'RO';
  if (cep >= 77000 && cep <= 77999) return 'TO';
  if (cep >= 78000 && cep <= 78899) return 'MT';
  if (cep >= 78900 && cep <= 78999) return 'RO';
  if (cep >= 79000 && cep <= 79999) return 'MS';
  if (cep >= 80000 && cep <= 87999) return 'PR';
  if (cep >= 88000 && cep <= 89999) return 'SC';
  if (cep >= 90000 && cep <= 99999) return 'RS';

  return 'RJ';
}

function ensureVesarleBrazilCountry(countrySelect) {
  if (!countrySelect || !countrySelect.options) return;

  var currentOption = countrySelect.options[countrySelect.selectedIndex];

  if (currentOption && ['brazil', 'brasil'].indexOf(normalizeVesarleText(currentOption.text || currentOption.value)) !== -1) {
    return;
  }

  for (var index = 0; index < countrySelect.options.length; index++) {
    var option = countrySelect.options[index];
    var label = normalizeVesarleText(option.text || option.value);
    var value = normalizeVesarleText(option.value);

    if (label === 'brazil' || label === 'brasil' || value === 'brazil' || value === 'brasil') {
      countrySelect.selectedIndex = index;
      countrySelect.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
  }
}

function ensureVesarleProvinceOption(provinceSelect, provinceCode) {
  if (!provinceSelect || !provinceCode) return;

  var code = provinceCode.toUpperCase();

  for (var index = 0; index < provinceSelect.options.length; index++) {
    var option = provinceSelect.options[index];

    if (String(option.value).toUpperCase() === code) {
      provinceSelect.value = option.value;
      return;
    }
  }

  provinceSelect.options.add(new Option(VESARLE_BRAZIL_PROVINCES[code] || code, code));
  provinceSelect.value = code;
}

function prepareVesarleShippingVariant(estimator) {
  var section = closestVesarleElement(estimator, '[data-section-type="product"]');
  var productData = readVesarleProductData(section);
  var formElement = section ? section.querySelector('form[action*="/cart/add"]') : null;
  var idInput = formElement ? formElement.querySelector('[name="id"]') : null;

  if (!productData || !productData.product || !productData.product.variants || !idInput) return;

  var currentVariantId = parseInt(idInput.value, 10);
  var variants = productData.product.variants;
  var currentVariant = variants.filter(function (variant) {
    return variant.id === currentVariantId;
  })[0];

  if (currentVariant && currentVariant.available) return;

  var availableVariant = variants.filter(function (variant) {
    return variant.available;
  })[0];

  if (!availableVariant) return;

  var originalValue = idInput.value;
  idInput.value = availableVariant.id;

  window.setTimeout(function () {
    if (idInput.value === String(availableVariant.id)) {
      idInput.value = originalValue;
    }
  }, 0);
}

function prepareVesarleShippingEstimator(estimator) {
  if (!estimator) return;

  var countrySelect = estimator.querySelector('[name="country"]');
  var provinceSelect = estimator.querySelector('[name="province"]');
  var zipInput = estimator.querySelector('[name="zip"]');
  var zip = zipInput ? zipInput.value : '';
  var provinceCode = inferVesarleProvinceFromZip(zip);

  ensureVesarleBrazilCountry(countrySelect);
  ensureVesarleProvinceOption(provinceSelect, provinceCode);
  prepareVesarleShippingVariant(estimator);
}

function initVesarleShippingEstimators(scope) {
  var root = scope || document;
  var estimators = root.querySelectorAll ? root.querySelectorAll('.product-form__shipping-estimator .shipping-estimator') : [];

  Array.prototype.forEach.call(estimators, function (estimator) {
    prepareVesarleShippingEstimator(estimator);
  });
}

function getVesarleFallbackShippingDeadline(name) {
  var normalizedName = normalizeVesarleText(name);

  if (normalizedName.indexOf('sedex') !== -1) return 'Entrega em 2 a 3 dias úteis';
  if (normalizedName.indexOf('loggi') !== -1 || normalizedName.indexOf('express') !== -1) return 'Entrega em 4 a 6 dias úteis';
  if (normalizedName.indexOf('jadlog') !== -1) return 'Entrega em 7 a 8 dias úteis';
  if (normalizedName.indexOf('padrao') !== -1 || normalizedName.indexOf('standard') !== -1) return 'Entrega em 3 a 5 dias úteis';

  return '';
}

function getVesarleDisplayShippingDeadline(rate, name) {
  return getVesarleShippingDeadline(rate) || getVesarleFallbackShippingDeadline(name);
}

function getVesarleShippingRatePriceValue(price) {
  var priceText = String(price || '').trim();
  var cleanPrice = priceText.replace(/[^\d,.-]/g, '');
  var numericPrice = 0;

  if (!cleanPrice) return NaN;

  if (cleanPrice.indexOf(',') !== -1) {
    numericPrice = parseFloat(cleanPrice.replace(/\./g, '').replace(',', '.'));
  } else {
    numericPrice = parseFloat(cleanPrice);
  }

  if (isNaN(numericPrice)) return NaN;

  if (cleanPrice.indexOf(',') === -1 && cleanPrice.indexOf('.') === -1 && numericPrice > 999) {
    numericPrice = numericPrice / 100;
  }

  return numericPrice;
}

function formatVesarleShippingRatePrice(price) {
  var priceText = String(price || '');

  if (/[.,]/.test(priceText)) {
    return formatVesarleMoney(parseFloat(priceText.replace(',', '.')) || 0);
  }

  if (window.Currency && typeof window.Currency.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
    return window.Currency.formatMoney(price, window.theme.moneyFormat);
  }

  var numericPrice = parseFloat(priceText);

  if (numericPrice > 999) {
    numericPrice = numericPrice / 100;
  }

  return formatVesarleMoney(numericPrice);
}

function renderVesarleShippingMessage(resultsElement, message, errors) {
  var html = '<div class="vesarle-shipping-results vesarle-shipping-results--message';

  if (errors && errors.length) {
    html += ' vesarle-shipping-results--error';
  }

  html += '"><p>' + escapeVesarleHtml(message) + '</p>';

  if (errors && errors.length) {
    html += '<div class="vesarle-shipping-errors">';
    errors.forEach(function (error) {
      html += '<span>' + escapeVesarleHtml(error) + '</span>';
    });
    html += '</div>';
  }

  html += '</div>';
  resultsElement.innerHTML = html;
  resultsElement.style.display = 'block';
}

function renderVesarleShippingRates(resultsElement, rates) {
  if (!resultsElement) return;

  if (!rates || !rates.length) {
    renderVesarleShippingMessage(resultsElement, 'Nenhuma opção de frete encontrada para este CEP.');
    return;
  }

  var lowestPrice = rates.reduce(function (lowest, rate) {
    var priceValue = getVesarleShippingRatePriceValue(rate.price);

    if (isNaN(priceValue) || priceValue < 0) return lowest;

    return priceValue < lowest ? priceValue : lowest;
  }, Infinity);

  var html = '<div class="vesarle-shipping-results">';
  html += '<p class="vesarle-shipping-results__summary">' + rates.length + ' opções de frete encontradas para este CEP</p>';
  html += '<div class="vesarle-shipping-results__list">';

  rates.forEach(function (rate, index) {
    var name = rate.presentment_name || rate.name || rate.code || 'Frete';
    var price = formatVesarleShippingRatePrice(rate.price);
    var deadline = getVesarleDisplayShippingDeadline(rate, name);
    var priceValue = getVesarleShippingRatePriceValue(rate.price);
    var isCheapest = lowestPrice !== Infinity && priceValue === lowestPrice;
    var rateClass = 'vesarle-shipping-rate' + (isCheapest ? ' vesarle-shipping-rate--cheapest' : '');

    name = name
      .replace(/\s*\(Melhor Envio\)/gi, '')
      .replace(/\s+\./g, ' ')
      .trim();

    html += '<div class="' + rateClass + '" data-vesarle-shipping-rate-index="' + index + '">';
    html += '<span class="vesarle-shipping-rate__main">';
    html += '<span class="vesarle-shipping-rate__name">' + escapeVesarleHtml(name) + '</span>';
    html += '<span class="vesarle-shipping-rate__deadline"' + (deadline ? '' : ' hidden') + '>' + escapeVesarleHtml(deadline) + '</span>';
    html += '</span>';
    html += '<strong class="vesarle-shipping-rate__price">' + escapeVesarleHtml(price) + '</strong>';
    html += '</div>';
  });

  html += '</div></div>';
  resultsElement.innerHTML = html;
  resultsElement.style.display = 'block';
}

function getVesarleCookie(name) {
  var value = '; ' + document.cookie;
  var parts = value.split('; ' + name + '=');

  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }

  return '';
}

function updateVesarleCartCookie(value) {
  var date = new Date();
  date.setTime(date.getTime() + 14 * 86400000);
  document.cookie = 'cart=' + value + '; expires=' + date.toUTCString() + '; path=/';
}

function getVesarleProductAddPayload(formElement) {
  var formData = new FormData(formElement);
  var id = formData.get('id');
  var quantity = parseInt(formData.get('quantity'), 10);

  return {
    id: parseInt(id, 10) || id,
    quantity: !isNaN(quantity) && quantity > 0 ? quantity : 1
  };
}

function getVesarleShippingRatesUrl(estimator) {
  var country = estimator.querySelector('[name="country"]').value;
  var province = estimator.querySelector('[name="province"]').value;
  var zip = estimator.querySelector('[name="zip"]').value;
  var cartUrl = window.routes && window.routes.cartUrl ? window.routes.cartUrl : '/cart';

  return cartUrl + '/shipping_rates.json?shipping_address[zip]=' + encodeURIComponent(zip) + '&shipping_address[country]=' + encodeURIComponent(country) + '&shipping_address[province]=' + encodeURIComponent(province);
}

function extractVesarleShippingErrors(payload) {
  if (!payload || typeof payload !== 'object') return [];

  return Object.keys(payload).reduce(function (errors, key) {
    var value = payload[key];

    if (Array.isArray(value)) {
      value.forEach(function (item) {
        errors.push(key + ' ' + item);
      });
    } else if (value) {
      errors.push(key + ' ' + value);
    }

    return errors;
  }, []);
}

function calculateVesarleProductShipping(estimator) {
  if (!window.fetch || !estimator) return;

  var resultsElement = estimator.querySelector('.shipping-estimator__results');
  var section = closestVesarleElement(estimator, '[data-section-type="product"]');
  var formElement = section ? section.querySelector('form[action*="/cart/add"]') : null;

  if (!resultsElement || !formElement) return;

  prepareVesarleShippingEstimator(estimator);
  renderVesarleShippingMessage(resultsElement, 'Calculando frete...');
  document.dispatchEvent(new CustomEvent('theme:loading:start'));

  var originalCartCookie = getVesarleCookie('cart');
  var tempCartCookie = 'temp-cart-cookie___' + Date.now() + parseInt(Math.random() * 1000, 10);
  var fakeCartCookie = 'fake-cart-cookie___' + Date.now() + parseInt(Math.random() * 1000, 10);

  if (!originalCartCookie) {
    updateVesarleCartCookie(tempCartCookie);
    originalCartCookie = getVesarleCookie('cart');
  }

  if (!originalCartCookie || originalCartCookie.length < 32) {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    renderVesarleShippingMessage(resultsElement, 'Não foi possível calcular o frete agora.');
    return;
  }

  updateVesarleCartCookie(fakeCartCookie);

  var cartAddUrl = window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add';

  fetch(cartAddUrl + '.js', {
    body: JSON.stringify(getVesarleProductAddPayload(formElement)),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    method: 'POST'
  }).then(function (response) {
    if (!response.ok) {
      throw new Error('add-to-cart');
    }

    return fetch(getVesarleShippingRatesUrl(estimator), {
      credentials: 'same-origin',
      method: 'GET'
    });
  }).then(function (response) {
    return response.json().then(function (payload) {
      if (!response.ok) {
        renderVesarleShippingMessage(resultsElement, 'Não foi possível calcular o frete para este CEP.', extractVesarleShippingErrors(payload));
        return;
      }

      renderVesarleShippingRates(resultsElement, payload.shipping_rates || []);
    });
  }).catch(function () {
    renderVesarleShippingMessage(resultsElement, 'Não foi possível calcular o frete agora.');
  }).then(function () {
    updateVesarleCartCookie(originalCartCookie);
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
  });
}

function parcelamento() {
  var priceElement = document.querySelector('.product-form__info-item--price .price--highlight, .product-form__info-item--price .price-list .price');
  var installmentsElement = document.querySelector('[data-product-installments]');

  if (!priceElement) return;

  if (!installmentsElement) {
    var priceList = priceElement.closest('.price-list');

    if (!priceList) return;

    installmentsElement = document.createElement('p');
    installmentsElement.className = 'product-installments';
    installmentsElement.setAttribute('data-product-installments', '');
    priceList.insertAdjacentElement('afterend', installmentsElement);
  }

  // o numero vem do campo do editor, injetado pelo theme.liquid; o 3 e so
  // rede de seguranca caso este arquivo rode antes daquele script
  var parcelas = (window.VESARLE && window.VESARLE.parcelas) || 3;
  var fator = (window.VESARLE && window.VESARLE.fatorParcela) || 1;

  var price = parseVesarleMoney(priceElement.textContent);
  var installment = price * fator / parcelas;

  installmentsElement.innerHTML = 'em até ' + parcelas + 'x de <span><b>' + formatVesarleMoney(installment) + '</b></span>';
}

function formatShippingEstimatorResults(resultsElement) {
  if (!resultsElement) return;

  if (resultsElement.querySelector('.vesarle-shipping-results')) {
    return;
  }

  var items = Array.prototype.slice.call(resultsElement.querySelectorAll('li'));
  var firstParagraph = resultsElement.querySelector('p');
  var rateItems = items.filter(function (item) {
    return /R\$\s?[\d.,]+/.test(item.textContent);
  });

  var errorItems = items.filter(function (item) {
    return !/R\$\s?[\d.,]+/.test(item.textContent) && item.textContent.replace(/\s+/g, ' ').trim();
  });

  if (!rateItems.length) {
    var message = firstParagraph ? firstParagraph.textContent.replace(/\{\{\s*count\s*\}\}/g, '').trim() : '';

    if (!message || /erros/i.test(message)) {
      message = 'Não foi possível calcular o frete para este CEP.';
    }

    var messageHtml = '<div class="vesarle-shipping-results vesarle-shipping-results--message';

    if (errorItems.length) {
      messageHtml += ' vesarle-shipping-results--error';
    }

    messageHtml += '"><p>' + escapeVesarleHtml(message) + '</p>';

    if (errorItems.length) {
      messageHtml += '<div class="vesarle-shipping-errors">';
      errorItems.forEach(function (item) {
        var text = item.textContent.replace(/\s+/g, ' ').trim();

        messageHtml += '<span>' + escapeVesarleHtml(text) + '</span>';
      });
      messageHtml += '</div>';
    }

    messageHtml += '</div>';
    resultsElement.innerHTML = messageHtml;
    return;
  }

  var lowestPrice = rateItems.reduce(function (lowest, item) {
    var text = item.textContent.replace(/\s+/g, ' ').trim();
    var match = text.match(/^(.*):\s*(R\$\s?.+)$/);
    var price = match ? match[2] : '';
    var priceValue = getVesarleShippingRatePriceValue(price);

    if (isNaN(priceValue) || priceValue < 0) return lowest;

    return priceValue < lowest ? priceValue : lowest;
  }, Infinity);

  var html = '<div class="vesarle-shipping-results">';
  html += '<p class="vesarle-shipping-results__summary">' + rateItems.length + ' opções de frete encontradas para este CEP</p>';
  html += '<div class="vesarle-shipping-results__list">';

  rateItems.forEach(function (item, index) {
    var text = item.textContent.replace(/\s+/g, ' ').trim();
    var match = text.match(/^(.*):\s*(R\$\s?.+)$/);
    var name = match ? match[1] : text;
    var price = match ? match[2] : '';
    var deadline = getVesarleFallbackShippingDeadline(name);
    var priceValue = getVesarleShippingRatePriceValue(price);
    var isCheapest = lowestPrice !== Infinity && priceValue === lowestPrice;
    var rateClass = 'vesarle-shipping-rate' + (isCheapest ? ' vesarle-shipping-rate--cheapest' : '');

    name = name
      .replace(/\s*\(Melhor Envio\)/gi, '')
      .replace(/\s+\./g, ' ')
      .trim();

    html += '<div class="' + rateClass + '" data-vesarle-shipping-rate-index="' + index + '">';
    html += '<span class="vesarle-shipping-rate__main">';
    html += '<span class="vesarle-shipping-rate__name">' + escapeVesarleHtml(name) + '</span>';
    html += '<span class="vesarle-shipping-rate__deadline" data-vesarle-shipping-deadline' + (deadline ? '' : ' hidden') + '>' + escapeVesarleHtml(deadline) + '</span>';
    html += '</span>';
    html += '<strong class="vesarle-shipping-rate__price">' + escapeVesarleHtml(price) + '</strong>';
    html += '</div>';
  });

  html += '</div></div>';
  resultsElement.innerHTML = html;
}

function initShippingEstimatorFormatting(scope) {
  var root = scope || document;
  var results = root.querySelectorAll ? root.querySelectorAll('.shipping-estimator__results') : [];

  Array.prototype.forEach.call(results, function (resultsElement) {
    if (closestVesarleElement(resultsElement, '.product-form__shipping-estimator')) return;
    if (resultsElement.dataset.vesarleObserverReady === 'true') return;

    var observer = new MutationObserver(function () {
      formatShippingEstimatorResults(resultsElement);
    });

    resultsElement.dataset.vesarleObserverReady = 'true';
    observer.observe(resultsElement, { childList: true, subtree: true });
    formatShippingEstimatorResults(resultsElement);
  });
}

if (window.languages) {
  window.languages.shippingEstimatorMultipleResults = 'Encontramos {{count}} opções de frete para este CEP:';
  window.languages.shippingEstimatorOneResult = 'Encontramos uma opção de frete para este CEP:';
  window.languages.shippingEstimatorNoResults = 'Nenhuma opção de frete encontrada para este CEP.';
  window.languages.shippingEstimatorErrors = 'Não foi possível calcular o frete para este CEP:';
}

document.addEventListener('DOMContentLoaded', function () {
  initVesarleProductMeta(document);
  initVesarleShippingEstimators(document);
  parcelamento();
  initShippingEstimatorFormatting(document);
});

document.addEventListener('click', function (event) {
  var button = closestVesarleElement(event.target, '[data-action="estimate-shipping"]');

  if (!button) return;

  var estimator = closestVesarleElement(button, '.shipping-estimator');

  if (!closestVesarleElement(button, '.product-form__shipping-estimator')) return;

  event.preventDefault();
  event.stopPropagation();

  if (event.stopImmediatePropagation) {
    event.stopImmediatePropagation();
  }

  calculateVesarleProductShipping(estimator);
}, true);

document.addEventListener('input', function (event) {
  if (!event.target || !event.target.matches || !event.target.matches('#product-shipping-estimator-zip')) return;

  prepareVesarleShippingEstimator(closestVesarleElement(event.target, '.shipping-estimator'));
});

document.addEventListener('change', function (event) {
  if (!event.target || !event.target.matches) return;

  if (event.target.matches('.product-form__single-selector')) {
    setTimeout(parcelamento, 180);
  }

  if (event.target.matches('#product-shipping-estimator-zip')) {
    prepareVesarleShippingEstimator(closestVesarleElement(event.target, '.shipping-estimator'));
  }
});

document.addEventListener('variant:changed', function (event) {
  var section = closestVesarleElement(event.target, '[data-section-type="product"]');

  if (!event.detail) return;

  updateVesarleProductMeta(section, event.detail.variant);
});

document.addEventListener('shopify:section:load', function (event) {
  initVesarleProductMeta(event.target);
  initVesarleShippingEstimators(event.target);
  initShippingEstimatorFormatting(event.target);
});
